import styled from 'styled-components/macro';
import { blue, blueHover } from '../../styles/colors';

export const Anchor = styled.div`
  color: ${blue};
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  &:hover {
    color: ${blueHover};
  }
`;
